import { useTheme } from '@approvalmax/theme';
import { CloseIcon, HistoryIcon } from '@approvalmax/ui';
import { Box, Button, Flex, Label } from '@approvalmax/ui/src/components';
import { actions } from 'modules/profile';
import { FC, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useMedia } from 'react-use';

import { useSaveToLocalStorage } from './WorkflowVersionHistoryPromotion.hooks';
import { messages } from './WorkflowVersionHistoryPromotion.messages';
import { WorkflowVersionHistoryPromotionProps } from './WorkflowVersionHistoryPromotion.types';

export const WorkflowVersionHistoryPromotion: FC<WorkflowVersionHistoryPromotionProps> = memo((props) => {
    const { company } = props;

    const { theme } = useTheme();
    const mediumOrBelowViewport = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);
    const dispatch = useDispatch();
    const { closePromotion, isClosedPromotion } = useSaveToLocalStorage();

    const handleTryIt = useCallback(() => {
        dispatch(actions.openConsentToStartTrialPopup(company, 'versionshistory_wfbuilder'));
    }, [company, dispatch]);

    if (isClosedPromotion) {
        return null;
    }

    return (
        <Box radius='xsmall' color='midnight30' spacing='4 4 4 8'>
            <Flex spacing='8' alignItems='center'>
                <HistoryIcon size={20} color='midnight70' />

                <Label spacing='0' color='midnight70'>
                    {mediumOrBelowViewport ? messages.shortText : messages.longText}
                </Label>

                <Button size='xsmall' color='mint80' onClick={handleTryIt}>
                    {messages.tryIt}
                </Button>

                <Button icon noPadding onClick={closePromotion} variant='text' color='blue100'>
                    <CloseIcon size={20} color='midnight90' />
                </Button>
            </Flex>
        </Box>
    );
});

WorkflowVersionHistoryPromotion.displayName = 'WorkflowVersionHistoryPromotion';
